import { TransactionType } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class CancelDriverJobRequest {
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    palletId: number;
    // @ApiProperty({
    //     enum: TransactionType,
    //     default: TransactionType.dispatch
    //   })
    //   transactionType: TransactionType;
  }
